import React from "react";
import { Toaster } from "react-hot-toast";

/**
 * AuthLayout - Simple layout wrapper for authentication pages
 * Minimal layout with just Toaster for notifications
 */
const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen">
      <Toaster />
      {children}
    </div>
  );
};

export default AuthLayout;
